import React from 'react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { KPIData, recentExceptions, regionalDistribution } from '../data/mockData';
import { Package, TrendingUp, AlertTriangle, Clock, ArrowUpRight, ArrowDownRight, MapPin } from 'lucide-react';
interface DashboardProps {
  onNavigate: (page: string, sub?: string | null, id?: string | null) => void;
}
export function Dashboard({
  onNavigate
}: DashboardProps) {
  return <div className="space-y-6" data-id="element-339">
      {/* KPI Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6" data-id="element-340">
        <Card className="border-l-4 border-l-bulog-blue cursor-pointer hover:shadow-lg transition-shadow" onClick={() => onNavigate('warehouse')} data-id="element-341">
          <div className="flex justify-between items-start gap-4" data-id="element-342">
            <div className="min-w-0 flex-1" data-id="element-343">
              <p className="text-sm font-medium text-gray-500 mb-2" data-id="element-344">
                Total Stok Nasional
              </p>
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 truncate" data-id="element-345">
                {(KPIData.totalStock / 1000).toFixed(1)}k{' '}
                <span className="text-sm font-normal text-gray-500" data-id="element-346">Ton</span>
              </h3>
            </div>
            <div className="p-3 bg-blue-50 rounded-lg flex-shrink-0" data-id="element-347">
              <Package className="text-bulog-blue" size={24} data-id="element-348" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm" data-id="element-349">
            <span className="text-green-600 flex items-center font-medium" data-id="element-350">
              <ArrowUpRight size={16} className="mr-1" data-id="element-351" />
              2.5%
            </span>
            <span className="text-gray-500 ml-2" data-id="element-352">dari bulan lalu</span>
          </div>
        </Card>

        <Card className="border-l-4 border-l-green-500 cursor-pointer hover:shadow-lg transition-shadow" onClick={() => onNavigate('sphp')} data-id="element-353">
          <div className="flex justify-between items-start gap-4" data-id="element-354">
            <div className="min-w-0 flex-1" data-id="element-355">
              <p className="text-sm font-medium text-gray-500 mb-2" data-id="element-356">
                Realisasi SPHP Hari Ini
              </p>
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 truncate" data-id="element-357">
                {KPIData.sphpToday}{' '}
                <span className="text-sm font-normal text-gray-500" data-id="element-358">Ton</span>
              </h3>
            </div>
            <div className="p-3 bg-green-50 rounded-lg flex-shrink-0" data-id="element-359">
              <TrendingUp className="text-green-600" size={24} data-id="element-360" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm" data-id="element-361">
            <span className="text-green-600 flex items-center font-medium" data-id="element-362">
              <ArrowUpRight size={16} className="mr-1" data-id="element-363" />
              12%
            </span>
            <span className="text-gray-500 ml-2" data-id="element-364">vs target harian</span>
          </div>
        </Card>

        <Card className="border-l-4 border-l-bulog-orange cursor-pointer hover:shadow-lg transition-shadow" onClick={() => onNavigate('warehouse')} data-id="element-365">
          <div className="flex justify-between items-start gap-4" data-id="element-366">
            <div className="min-w-0 flex-1" data-id="element-367">
              <p className="text-sm font-medium text-gray-500 mb-2" data-id="element-368">
                Stok Aging (&gt;6 Bulan)
              </p>
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 truncate" data-id="element-369">
                {(KPIData.agingStock / 1000).toFixed(1)}k{' '}
                <span className="text-sm font-normal text-gray-500" data-id="element-370">Ton</span>
              </h3>
            </div>
            <div className="p-3 bg-orange-50 rounded-lg flex-shrink-0" data-id="element-371">
              <Clock className="text-bulog-orange" size={24} data-id="element-372" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm" data-id="element-373">
            <span className="text-red-600 flex items-center font-medium" data-id="element-374">
              <ArrowUpRight size={16} className="mr-1" data-id="element-375" />
              5%
            </span>
            <span className="text-gray-500 ml-2" data-id="element-376">perlu perhatian</span>
          </div>
        </Card>

        <Card className="border-l-4 border-l-red-500 cursor-pointer hover:shadow-lg transition-shadow" onClick={() => onNavigate('warehouse')} data-id="element-377">
          <div className="flex justify-between items-start gap-4" data-id="element-378">
            <div className="min-w-0 flex-1" data-id="element-379">
              <p className="text-sm font-medium text-gray-500 mb-2" data-id="element-380">
                Gudang Kritis (&gt;90%)
              </p>
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 truncate" data-id="element-381">
                {KPIData.criticalWarehouses}{' '}
                <span className="text-sm font-normal text-gray-500" data-id="element-382">
                  Lokasi
                </span>
              </h3>
            </div>
            <div className="p-3 bg-red-50 rounded-lg flex-shrink-0" data-id="element-383">
              <AlertTriangle className="text-red-600" size={24} data-id="element-384" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm" data-id="element-385">
            <span className="text-green-600 flex items-center font-medium" data-id="element-386">
              <ArrowDownRight size={16} className="mr-1" data-id="element-387" />2
            </span>
            <span className="text-gray-500 ml-2" data-id="element-388">dari minggu lalu</span>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-389">
        {/* Map Placeholder */}
        <Card title="Peta Sebaran Stok & Penyaluran" className="lg:col-span-2" data-id="element-390">
          <div className="h-80 bg-gray-100 rounded-lg flex items-center justify-center relative overflow-hidden" data-id="element-391">
            <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#0056A6_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-392"></div>
            <div className="text-center z-10" data-id="element-393">
              <MapPin size={48} className="mx-auto text-gray-400 mb-3" data-id="element-394" />
              <p className="text-gray-500 font-medium text-lg" data-id="element-395">
                Visualisasi Peta Indonesia
              </p>
              <p className="text-sm text-gray-400 mt-1" data-id="element-396">
                Heatmap stok dan realisasi per provinsi
              </p>
            </div>

            {/* Fake map points */}
            <div className="absolute top-1/3 left-1/4 z-20" data-id="element-397">
              <div className="w-4 h-4 bg-bulog-blue rounded-full animate-pulse shadow-lg" data-id="element-398"></div>
              <div className="mt-1 bg-white px-2 py-0.5 rounded shadow-md text-xs font-bold" data-id="element-399">
                JKT
              </div>
            </div>
            <div className="absolute bottom-1/3 right-1/3 z-20" data-id="element-400">
              <div className="w-4 h-4 bg-green-500 rounded-full animate-pulse shadow-lg" data-id="element-401"></div>
              <div className="mt-1 bg-white px-2 py-0.5 rounded shadow-md text-xs font-bold" data-id="element-402">
                SBY
              </div>
            </div>
            <div className="absolute top-1/4 right-1/4 z-20" data-id="element-403">
              <div className="w-4 h-4 bg-bulog-orange rounded-full animate-pulse shadow-lg" data-id="element-404"></div>
              <div className="mt-1 bg-white px-2 py-0.5 rounded shadow-md text-xs font-bold" data-id="element-405">
                MKS
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4" data-id="element-406">
            {regionalDistribution.map((reg, idx) => <div key={idx} className="text-center" data-id="element-407">
                <p className="text-xs font-medium text-gray-500 mb-2 truncate" data-id="element-408">
                  {reg.region}
                </p>
                <div className="h-2 w-full bg-gray-100 rounded-full overflow-hidden" data-id="element-409">
                  <div className="h-full bg-bulog-blue rounded-full transition-all duration-500" style={{
                width: `${reg.realization / reg.target * 100}%`
              }} data-id="element-410"></div>
                </div>
                <p className="text-xs font-bold mt-2 text-gray-900" data-id="element-411">
                  {Math.round(reg.realization / reg.target * 100)}%
                </p>
              </div>)}
          </div>
        </Card>

        {/* Recent Exceptions */}
        <Card title="Peringatan & Exception" description="Update terbaru dari sistem" action={<button onClick={() => onNavigate('reports', 'audit')} className="text-sm text-bulog-blue hover:text-bulog-blue-dark font-medium transition-colors" data-id="element-413">
              Lihat Semua
            </button>} data-id="element-412">
          <div className="space-y-3" data-id="element-414">
            {recentExceptions.map(ex => <div key={ex.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors border border-gray-100 cursor-pointer" onClick={() => onNavigate('reports', 'audit')} data-id="element-415">
                <div className={`mt-0.5 p-2 rounded-full flex-shrink-0 ${ex.severity === 'High' ? 'bg-red-100 text-red-600' : ex.severity === 'Medium' ? 'bg-orange-100 text-bulog-orange' : 'bg-yellow-100 text-yellow-600'}`} data-id="element-416">
                  <AlertTriangle size={16} data-id="element-417" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-418">
                  <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-419">
                    {ex.type}
                  </p>
                  <p className="text-sm text-gray-600 line-clamp-2 leading-relaxed" data-id="element-420">
                    {ex.message}
                  </p>
                  <p className="text-xs text-gray-400 mt-2" data-id="element-421">{ex.date}</p>
                </div>
              </div>)}
          </div>
          <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-422">
            <Button variant="outline" className="w-full" onClick={() => onNavigate('reports', 'audit')} data-id="element-423">
              Buat Laporan Insiden
            </Button>
          </div>
        </Card>
      </div>
    </div>;
}